import { AuthService } from './../../../services/auth.service';
import { Admin } from './../../../models/admin';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { PNotifyService } from '../../../services/pnotify.service';
import * as moment from 'moment';

@Component({
  selector: 'app-admin-edit',
  templateUrl: './admin-edit.component.html',
  styleUrls: ['./admin-edit.component.css']
})
export class AdminEditComponent implements OnInit {

  user: any;
  admin: Admin;
  passwordChange = {
    enabled: false,
    password: '',
    passwordConfirm: ''
  };
  isAccountPage: boolean;
  reservedUsernames: string[];
  pnotify = undefined;
  // ----- Start DatePicker -----------
  dateTimeFilter = (d: Date): boolean => {
    return true;
  }
  // ----- End DatePicker -----------

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    private authService: AuthService,
    pnotifyService: PNotifyService
  ) {
    this.user = authService.getUser();
    this.admin = new Admin();
    this.reservedUsernames = [];
    this.isAccountPage = (this.router.url.indexOf('/account') === 0);
    this.route.params.subscribe(params => {
      const id = this.isAccountPage ? this.user.id : params['id'];
      this.http.get(
        '/api/admin/' + id
      ).subscribe((admin: Admin) => {
        this.admin = admin;
        this.http.get(
          '/api/admin/reservedUsernames/' + id
        ).subscribe((usernames: any[]) => {
          for (let i = 0; i < usernames.length; i++) {
            this.reservedUsernames.push(usernames[i].username);
          }
        });
      });
    });
    this.pnotify = pnotifyService.getPNotify();
  }

  ngOnInit() {
  }

  onUsernameChange() {
    this.admin.username = this.admin.username.replace(/\s/g, '');
  }

  onSubmit(): void {
    this.admin.time = moment.utc(this.admin.time).format('YYYY-MM-DD HH:mm:ss');
    this.http.put(
      '/api/admin/' + this.admin.id,
      {
        admin: this.admin,
        passwordChange: this.passwordChange
      }
    ).subscribe(
      (admin: Admin) => {
        this.admin = admin;
        this.router.navigate(this.isAccountPage ? ['/account/admin/view'] : ['/admin/view', this.admin.id]);
      },
      (error) => {
        this.pnotify.error({
          title: 'Erreur',
          text: 'Une erreur est survenue !',
          stack: {
            firstpos1: 70, firstpos2: 10,
            modal: true,
            overlay_close: true
          },
          hide: false,
          modules: {
            Confirm: {
              confirm: true,
              buttons: [
                {
                  text: 'Ok',
                  addClass: 'btn btn-chico',
                  click: notice => {
                    notice.close();
                  }
                }
              ]
            }
          }
        });
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/components/admin/admin-edit/admin-edit.component.ts